import React from 'react';

export const LazyRosterHeader = React.lazy(() =>
  import(/* webpackChunkName: "roster-header" */ './header/RosterHeader'),
);

export const LazyRosterRoute = React.lazy(() =>
  import(/* webpackChunkName: "roster-route" */ './route/RosterRoute'),
);

export { primeInitialPage } from './Roster/data/useRosterSearch';
